import { FC, PropsWithChildren } from 'react';
import Head from 'next/head';
import { IMeta } from '../../interfaces/meta.interface';
import { ABSOLUTE_URL } from '@/helpers/variables';
import Script from 'next/script';

const Meta: FC<PropsWithChildren<IMeta>> = ({ title, description, pageHref, canonicalHref, cover, children, robotsNoFollow }) => {
  const findPageNumber = () => {
    const splitHref = pageHref?.split('/');

    //Client page number
    if (pageHref?.includes('page=') && !!splitHref?.length) {
      return splitHref[splitHref.length - 1];
    }

    //Server page number
    if (!!splitHref?.length) {
      const splitHrefLength = Number(splitHref?.length - 1);
      const pageNumber = splitHref[splitHrefLength];
      return Number(pageNumber) > 0 ? `page=${pageNumber}` : '';
    }

    //Plain pages
    return '';
  };

  return (
    <>
      <Head>
        {/* scripts for production */}
        <script type="text/javascript" src="/static/yandex-context-cb.js"></script>
        <noscript>
          <div>
            <img src="https://mc.yandex.ru/watch/87192891" style={{ position: 'absolute', left: '-9999px' }} />
          </div>
        </noscript>

        <script src="https://yandex.ru/ads/system/context.js" async />
        {/* scripts for production */}
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="og:title" content={title} />
        <meta name="og:description" content={description} />
        <meta property="og:url" content={`${ABSOLUTE_URL}${canonicalHref}${findPageNumber()}`} />
        {!!robotsNoFollow ? <meta name="robots" content="noindex, nofollow" /> : ``}
        <link rel="canonical" href={`${ABSOLUTE_URL}${canonicalHref}`} />
        {cover ? (
          <>
            <meta property="og:type" content="books.book" />
            <meta property="og:image" content={cover}></meta>
          </>
        ) : (
          <>
            <meta property="og:image" content="/images/logo.png"></meta>
          </>
        )}
        <link rel="icon" type="image/svg" href="/favicon/favicon.svg" />
        <link rel="shortcut icon" href="/favicon/favicon.ico" />
      </Head>
      <Script id="yandex-metrika" strategy="afterInteractive">
      {`
      (function(m,e,t,r,i,k,a){
        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        k=e.createElement(t),a=e.getElementsByTagName(t)[0];
        k.async=1;k.src=r;a.parentNode.insertBefore(k,a);
      })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

      ym(87192891, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
      });
      `}
      </Script>
      {children}
    </>
  );
};

export default Meta;
